import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from "react-router-dom";
import axios from 'axios';
import { BaseURL, uniqueToken } from '../../../api/DataApis';
import "../../Users/User.css"; // Assuming you have some basic CSS here

function View(props) {
  document.title = "Offer Details | View";
  let navigate = useNavigate();
  let location = useLocation();
  const params = useParams();
  const offerID = params.wid;
  console.log("offerID :", offerID);

 
  const [OfferDetails, setOfferDetails] = useState([]);
  const [loading, setLoading] = useState(true); // State to manage loader

  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/offer/edit/${offerID}`;
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
console.log("ressssss", res);
     
        setOfferDetails(res.data?.data[0]); // Set the first item in the data array
      
    } catch (error) {
      console.error("Error fetching charger data:", error);
    } finally {
      setLoading(false); // Stop the loader when data is fetched
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  console.log("data", OfferDetails);

  return (
    <div className="container-fluid">
      <div className="row justify-content-center">
        <div className="col-sm-12">
          <div className="card mt-4 p-4">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                <h2 className="text-center">Offer Details</h2>

                {/* Centered Image */}
                {OfferDetails?.master_image && (
                  <div className="text-center mb-4">
                    <img
                      src={OfferDetails.imageURL}
                      alt="Station"
                      style={{
                        width: '200px',
                        height: '200px',
                        objectFit: 'cover',
                        borderRadius: '50%',
                        border: '3px solid #ddd'
                      }}
                    />
                  </div>
                )}

                <div className="row">
                  <div className="col-sm-6">
                    <p><strong>Offer Title:</strong> {OfferDetails?.title}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Offer Description:</strong> {OfferDetails?.description}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Amount:</strong> {OfferDetails?.amount}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Percentage:</strong> {OfferDetails?.percentage}</p>
                  </div>
               
                  <div className="col-sm-6">
                    <p><strong>Status:</strong> {OfferDetails?.status}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Created Date:</strong> {OfferDetails?.createdAt}</p>
                  </div>
                  <div className="col-sm-6">
                    <p><strong>Updated Date:</strong> {OfferDetails?.updatedAt}</p>
                  </div>
               
              
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default View;
